<template>
  <v-card color="#f0f2f5" style="min-height: 100vh">
    <!-- Barra de herramientas premium -->
    <v-toolbar
      dark
      flat
      color="#2c3e50"
      style="position: sticky; top: 0; z-index: 10"
    >
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title class="font-weight-bold ml-2">
        Vista Previa de Contratos
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        :loading="isGenerating"
        color="success"
        depressed
        class="font-weight-bold px-6"
        @click="downloadBatchPDFs"
      >
        <v-icon left>mdi-file-download</v-icon>
        DESCARGAR PDF
      </v-btn>
    </v-toolbar>

    <div class="preview-container">
      <div
        v-for="(lot, index) in lotes"
        :key="'preview-' + lot.FltID"
        class="preview-page-wrapper"
      >
        <!-- El contenedor principal de la hoja ahora tiene el tamaño exacto de una A4 -->
        <div class="a4-sheet">
          <div class="document-sheet" :id="'contract-content-' + index">
            <!-- Encabezado de preview (se ignora en el PDF) -->
            <div class="preview-header">
              <img
                src="/static/logo_sp.png"
                alt="Logo"
                class="preview-logo-img"
              />
            </div>

            <div class="doc-content-wrapper">
              <div class="doc-title-block">
                <h1 class="main-title">CONTRATO PRIVADO DE COMPRA – VENTA</h1>
                <h2 class="sub-title">
                  PRODUCTO: {{ lot.TypeCultiveText || "MANGO" }}
                  {{ lot.TypeCropText || "" }}
                </h2>
                <h2 class="sub-title">
                  CAMPAÑA {{ contrato.CmaName || "2025 / 2026" }}
                </h2>
              </div>

              <div class="doc-divider"></div>

              <div class="doc-body">
                <p>
                  Conste por el presente documento, el Contrato Privado de
                  Compra - Venta de
                  <strong>{{
                    lot.TypeCultiveText || "Mango Convencional"
                  }}</strong
                  >, que celebran, de una parte,
                  <strong>{{ contrato.PrdCardName || "---" }}</strong> con RUC
                  N° <strong>{{ lot.PrdRuc || "____________" }}</strong
                  >, con domicilio fiscal en
                  <strong>{{ lot.PrdAddress || "____________" }}</strong
                  >, debidamente representada por su titular Gerente Sr.
                  <strong>{{ lot.PrdRepresentative || "____________" }}</strong
                  >, identificado con DNI N°
                  <strong>{{ lot.PrdDni || "____________" }}</strong> en
                  adelante denominado <strong>EL AGRICULTOR</strong>, y de la
                  otra parte, la empresa
                  <strong>SUNSHINE EXPORT S.A.C.</strong>, con RUC No
                  20329725431, con domicilio en CAR.TAMBOGRANDE-LAS LOMAS KM.
                  1077 PIURA - PIURA - TAMBO GRANDE, debidamente representada
                  por su Gerente de Operaciones Agrícolas Sr. Carlos Daniel
                  Sánchez Cueva, identificado con DNI N° 40685022, a quien en
                  adelante se le denominará <strong>EL EXPORTADOR</strong>, de
                  acuerdo a los términos y condiciones siguientes:
                </p>

                <h3 class="clause-title">PRIMERA.- DE LAS PARTES</h3>
                <p>
                  EL AGRICULTOR es una persona jurídica/natural dedicada a la
                  actividad agrícola, entre las cuales se encuentra el cultivo
                  de
                  {{ lot.TypeCultiveText || "mango convencional" }}; dicho
                  cultivo se realiza en un área aproximadamente de
                  <strong>{{ lot.FltHectares || "---" }}</strong> hectáreas de
                  su propiedad ubicada en
                  <strong>{{ lot.FagAddress || "---" }}</strong> Distrito
                  <strong>{{ lot.SzoIDText || "---" }}</strong
                  >, provincia <strong>{{ lot.ZonIDText || "---" }}</strong
                  >, Departamento <strong>PIURA</strong>.
                </p>
                <p>
                  La parcela cuenta con
                  <strong>{{ lot.FltPlants || "---" }}</strong> árboles en
                  producción de mango, y se estima una producción total
                  exportable de
                  <strong>{{ lot.FltVolume || "---" }}</strong> toneladas para
                  la presente campaña.
                </p>
                <p>
                  EL AGRICULTOR declara tener título de propiedad y/o documento
                  legal que así lo acredite lo cual demuestra que tiene pleno
                  dominio y disponibilidad del predio antes señalado.
                </p>

                <h3 class="clause-title">SEGUNDA.- OBJETO DEL CONTRATO</h3>
                <p>
                  Por el presente documento, EL AGRICULTOR se compromete a
                  vender y a entregar a favor de EL EXPORTADOR, la totalidad de
                  la producción de
                  {{ lot.TypeCultiveText || "mango convencional" }} del área
                  descrita en la cláusula primera del presente contrato, durante
                  el periodo de la campaña
                  {{ contrato.CmaName || "2025 - 2026" }}.
                </p>

                <h3 class="clause-title">TERCERA.- COSECHA</h3>
                <p>
                  EL EXPORTADOR se compromete a cosechar, a su costo, el mango
                  ofrecido por EL AGRICULTOR, para lo cual se encargará de
                  llevar personal de cosecha a los campos. Serán de cargo de EL
                  EXPORTADOR todos los sueldos, salarios, y prestaciones que
                  correspondan al personal.
                </p>

                <h3 class="clause-title">
                  CUARTA.- OBLIGACIONES DE LAS PARTES
                </h3>
                <p>
                  EL AGRICULTOR deberá entregar a EL EXPORTADOR la producción
                  del cultivo de mango, de acuerdo al programa de cosecha
                  establecida y comunicada días antes por el área Técnica de EL
                  EXPORTADOR.
                </p>

                <h3 class="clause-title">SEXTA.- TRANSACCIONES ECONÓMICAS</h3>
                <p>
                  El volumen a comprar y precio a pagar semanalmente por cada
                  una de las calidades de fruta así como las condiciones de pago
                  serán comunicados por EL EXPORTADOR a EL AGRICULTOR. El precio
                  referencial actual es de
                  <strong>S/. {{ contrato.PctPrice || "0.00" }}</strong> por
                  Kilogramo.
                </p>

                <h3 class="clause-title">DÉCIMO CUARTA.- JURISDICCIÓN</h3>
                <p>
                  Para los efectos del presente contrato, las partes renuncian
                  expresamente al fuero de sus domicilios y se someten a la
                  jurisdicción de los Jueces y Tribunales de Piura.
                </p>

                <div class="signatures-grid">
                  <div class="sig-col">
                    <div class="sig-line"></div>
                    <p class="sig-name">SUNSHINE EXPORT SAC</p>
                    <p class="sig-id">Carlos Daniel Sánchez Cueva</p>
                  </div>
                  <div class="sig-col">
                    <div class="sig-line"></div>
                    <p class="sig-name">EL AGRICULTOR</p>
                    <p class="sig-detail">
                      RUC: {{ lot.PrdRuc || "____________" }}
                    </p>
                  </div>
                </div>

                <div class="annex-section">
                  <p class="annex-text">
                    <strong>ACEPTO LAS CONDICIONES DEL ANEXO 3.</strong>
                  </p>
                  <div class="annex-footer">
                    <span>FIRMA: __________________</span>
                    <span>FECHA: {{ hoy.fecha }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Overlay de progreso -->
    <v-overlay :value="isGenerating" z-index="100">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="64"
          color="success"
        ></v-progress-circular>
        <div class="mt-4 white--text headline font-weight-light">
          Generando Documentos...
        </div>
        <div class="mt-2 grey--text">{{ progressText }}</div>
      </div>
    </v-overlay>
  </v-card>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "PdfContractProducer",
  props: {
    contrato: { type: Object, required: true },
    lotes: { type: Array, required: true },
  },
  data() {
    return {
      isGenerating: false,
      progressText: "",
      logoBase64: null,
    };
  },
  computed: {
    hoy() {
      const d = new Date();
      return {
        dia: d.getDate(),
        mes: new Intl.DateTimeFormat("es-ES", { month: "long" }).format(d),
        anio: d.getFullYear(),
        fecha: this.$moment(d).format("DD/MM/YYYY"),
      };
    },
  },
  mounted() {
    this.preloadLogo();
  },
  methods: {
    async preloadLogo() {
      try {
        const response = await fetch("/static/logo_sp.png");
        const blob = await response.blob();
        const reader = new FileReader();
        return new Promise((resolve) => {
          reader.onloadend = () => {
            this.logoBase64 = reader.result;
            resolve();
          };
          reader.readAsDataURL(blob);
        });
      } catch (e) {
        console.error("Error preloading logo:", e);
      }
    },

    async downloadBatchPDFs() {
      if (this.isGenerating) return;
      this.isGenerating = true;

      try {
        if (!this.logoBase64) await this.preloadLogo();

        const sanitize = (str) => {
          return str
            ? str.trim().replace(/[/\\?%*:|"<>]/g, "").replace(/\s+/g, "_")
            : "";
        };

        for (let i = 0; i < this.lotes.length; i++) {
          const lot = this.lotes[i];
          this.progressText = `Generando PDF (${i + 1}/${this.lotes.length})`;

          const element = document.getElementById(`contract-content-${i}`);
          
          const prdName = sanitize(this.contrato.PrdCardName || "");
          const fundoName = sanitize(lot.FagName || "");
          const loteName = sanitize(lot.FltName || "");
          const filename = `CONTRATO_${prdName}_${fundoName}_${loteName}.pdf`;

          // ESTRATEGIA DE CENTRADO ABSOLUTO:
          // 1. Capturamos el elemento con el ancho EXACTO del área imprimible (170mm).
          // 2. Aplicamos márgenes laterales de 20mm en el motor PDF para centrarlo (20 + 170 + 20 = 210mm A4).
          // 3. Esto evita el escalado que causaba que se viera "pequeño" o "movido".
          const opt = {
            margin: [25, 20, 20, 20], // Margen Top de 25mm para el logo
            filename: filename,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
              scale: 2.2,
              useCORS: true,
              width: 642, // Equivale a 170mm a 96dpi (para forzar el ancho de captura)
              ignoreElements: (el) => el.classList.contains("preview-header"),
            },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          };

          const worker = html2pdf().set(opt).from(element).toPdf().get("pdf");

          await worker.then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let j = 1; j <= totalPages; j++) {
              pdf.setPage(j);
              if (this.logoBase64) {
                pdf.addImage(this.logoBase64, "PNG", 20, 8, 36, 0);
              }
              pdf.setFontSize(8);
              pdf.setTextColor(150);
              pdf.text(
                `Contrato de Productor - ${this.contrato.PrdCardName || ""} - ${lot.FagName || ""} - Lote ${lot.FltName || ""} - Página ${j} de ${totalPages}`,
                20,
                287,
              );
            }
          });

          await worker.save();
          if (this.lotes.length > 1)
            await new Promise((r) => setTimeout(r, 700));
        }
      } catch (error) {
        console.error("PDF Error:", error);
      } finally {
        this.isGenerating = false;
      }
    },
  },
};
</script>

<style scoped>
.preview-container {
  padding: 40px 20px;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
}

/* Contenedor que simula una hoja A4 real en pantalla */
.a4-sheet {
  width: 210mm;
  min-height: 297mm;
  background: white;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

/* El elemento que se captura es el contenido INTERNO del área imprimible */
.document-sheet {
  width: 170mm; /* Ancho imprimible (210 - 20 - 20) */
  margin: 0 auto; /* Centrado dentro de la hoja A4 */
  background: white;
}

.preview-header {
  height: 25mm;
  padding-top: 8mm;
  margin-bottom: 2mm;
}

.preview-logo-img {
  width: 36mm;
  height: auto;
}

.doc-content-wrapper {
  padding-bottom: 20mm;
  font-family: "Times New Roman", Times, serif;
  font-size: 11pt;
  line-height: 1.5;
  color: #1a1a1a;
}

.doc-title-block {
  text-align: center;
  margin-bottom: 20px;
}

.main-title {
  font-size: 14pt;
  font-weight: bold;
  text-decoration: underline;
}

.sub-title {
  font-size: 11pt;
  font-weight: bold;
}

.doc-divider {
  height: 1px;
  background: #000;
  margin: 15px 0;
}

.doc-body p {
  text-align: justify;
  margin-bottom: 10pt;
}

.clause-title {
  font-weight: bold;
  font-size: 11pt;
  margin-top: 14pt;
  margin-bottom: 6pt;
}

.signatures-grid {
  display: flex;
  justify-content: space-between;
  margin-top: 30pt;
}

.sig-col {
  width: 45%;
  text-align: center;
}

.sig-line {
  border-top: 1px solid #000;
  margin-bottom: 5px;
}

.sig-name {
  font-weight: bold;
  font-size: 10pt;
}

.annex-section {
  border: 1px solid #eee;
  padding: 12px;
  background: #fdfdfd;
  font-size: 9.5pt;
  margin-top: 25px;
}

.annex-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
